import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EmailReplyMeta, SmtpData, SmtpForm } from '@models/models';
import { MessageService } from '@services/helpers/message-service/message.service';
import { EmailAlertModalComponent } from '@web-components/settings/email-settings-section/modals/email-alert-modal/email-alert-modal.component';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { SNModalService } from '@web-services/modal/snModal.service';
import { EmailSettingsService } from '@services/settings/email-settings.service';
import { finalize } from 'rxjs/operators';
import { EmailSettingsDataService } from '@services/settings/email-settings.data.service';

@Component({
	selector: 'smtp-modal',
	template: require('./smtp-modal.component.html'),
	styles: [require('./smtp-modal.component.scss')]
})
export class SmtpModalComponent {
	@Input() smtpData: SmtpData;
	@Output() onSaveSmtp: EventEmitter<void> = new EventEmitter();

	confirmModalRef: NgbModalRef;
	btnDisable: boolean;
	unsubscribe: Subject<void> = new Subject();

	constructor(
		private messageService: MessageService,
		private modalService: SNModalService,
		private emailSettingsService: EmailSettingsService,
		private emailSettingsDataService: EmailSettingsDataService
	) {}

	saveSMTPServerSettings(formData: SmtpForm): void {
		if (
			this.smtpData.replyConfirmationHtml &&
			this.smtpData.replySettingsMetadata &&
			this.smtpData.replySettingsMetadata.enabled
		) {
			this.openConfirmModal();
		} else {
			this.saveSmtpConfig(formData);
		}
	}

	closeModal(): void {
		this.onSaveSmtp.emit();
	}

	numberOnly(event): boolean {
		const charCode = event.which ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}

	onEmailConfirm(data: EmailReplyMeta): void {
		this.smtpData.replySettingsMetadata = JSON.parse(JSON.stringify(data));
		this.smtpData.replySettingsMetadata.enabled = true;
	}

	private saveSmtpConfig(formData: SmtpForm): void {
		this.btnDisable = true;
		formData.from = this.smtpData.from;
		formData.username = formData.serverUsername.toLowerCase();
		formData.withSSL = !!formData.withSSL;
		formData.password = this.smtpData.passwordMask;
		formData.port = this.smtpData.port.toString();

		if (this.smtpData.replySettingsMetadata) {
			formData.receiveReplies = !!this.smtpData.replySettingsMetadata.enabled;
			formData.accountCredentialId = this.smtpData.replySettingsMetadata.replyAccountCredentialId;
		}

		if (!this.emailSettingsService.isSMTPSettingsValid(formData)) {
			this.btnDisable = false;
			return;
		}

		this.messageService.showToaster('i_0', 'emailSettings');

		this.emailSettingsDataService
			.saveSMTPServerSettings(formData)
			.pipe(finalize((): boolean => (this.btnDisable = false)))
			.subscribe(
				(): void => this.successSaveSMTPConnection(),
				(error): void => this.errorSaveSMTPConnection(error)
			);
	}

	private successSaveSMTPConnection(): void {
		this.messageService.showToaster('s_2', 'emailSettings', 'SMTP email');
		this.closeModal();
	}

	private errorSaveSMTPConnection(result): void {
		const { error } = result;
		const { errorCode, errorTitle, errorMessage } = error;

		errorCode
			? this.messageService.showErrorFromBackend(errorTitle, errorMessage)
			: this.messageService.showToaster('e_2', 'emailSettings');
	}

	private openConfirmModal(): void {
		this.confirmModalRef = this.modalService.openModal(
			EmailAlertModalComponent,
			{
				windowClass: 'ng-bootstrap-modal__small'
			}
		);

		document.body.classList.remove('modal-open');

		this.confirmModalRef.componentInstance.btnDisabled = false;
		this.confirmModalRef.componentInstance.messageToShow = this.smtpData.replyConfirmationHtml;

		this.confirmModalRef.result.then((): void => {
			document.body.classList.add('modal-open');
			this.closeModal();
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/settings/email-settings-section/modals/smtp-modal/smtp-modal.component.ts